// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"31d6cfe0","208":"31d6cfe0","372":"31d6cfe0","553":"31d6cfe0","788":"31d6cfe0","789":"31d6cfe0","882":"31d6cfe0"}[chunkId] + ".chunk.css";
};